import { render } from "./App.vue?vue&type=template&id=d81e4b38"
const script = {}

import "./App.vue?vue&type=style&index=0&id=d81e4b38&lang=css"

import exportComponent from "C:\\Users\\marti\\Documents\\dev\\JavaScript\\live-chat\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__